import React, { useEffect } from 'react';
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { Link } from 'react-router-dom';
import "./Servicespagesection.css";
import Cosection from '../components/Cosections';

const Servicespagesection = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const items = document.querySelectorAll('.timeline li');

    function isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    function callbackFunc() {
      for (let i = 0; i < items.length; i++) {
        if (isElementInViewport(items[i])) {
          items[i].classList.add('in-view');
        }
      }
    }

    window.addEventListener('load', callbackFunc);
    window.addEventListener('resize', callbackFunc);
    window.addEventListener('scroll', callbackFunc);

    return () => {
      window.removeEventListener('load', callbackFunc);
      window.removeEventListener('resize', callbackFunc);
      window.removeEventListener('scroll', callbackFunc);
    };
  }, []);

  const services = [
    { title: 'Federal & State Tax Filing', description: 'Your guide through the tax jungle. Accurate filing, expert planning, all tax needs covered. Free yourself, choose Sumukha Tax Filers!', link: '/federal' },
    { title: 'Amendment', description: 'Amend your tax return with expert help for accuracy and efficiency. Correct errors, claim deductions, and maximize your refund.', link: '/amendment' },
    { title: 'ITIN Preparation', description: 'Streamlined ITIN application process by certified agents. Expert assistance for Form W-7, identity document certification, and IRS submission.', link: '/itinpreparation' },
    { title: 'FBAR & FATCA', description: 'FBAR (FINCEN114) & FATCA filing made easy. Report foreign financial accounts & assets accurately. Avoid penalties.', link: '/fbar' },
    { title: 'W4 Assistance', description: 'Optimize your W-4 with expert assistance from Sumukha Tax Filers. Claim allowances, ensure accuracy, and align withholding with your financial goals.', link: '/w4assistance' },
    { title: 'Tax Extension Filing', description: 'Request a tax filing extension with Sumukha Tax Filers. Get expert assistance, avoid penalties, and ensure timely compliance.', link: '/taxextension' },
    { title: 'Estimate Tax Payments', description: 'Let Sumukha Tax Filers handle your estimated taxes to avoid IRS penalties. Our experts ensure accurate filings, saving you time and providing peace of mind.', link: '/estimatetax' },
    { title: 'Tax Planning', description: 'Sumukha Tax Filers offers expert tax planning by CPAs and EAs to minimize liabilities. Personalized strategies for long-term financial success.', link: '/taxplanning' },
    { title: 'Tax Representation before IRS', description: 'Sumukha Tax Filers assures expert support through IRS audits. Trust our professionals for comprehensive representation and resolution.', link: '/representation' },
    { title: 'Filing Options', description: 'Your trusted partner for seamless tax filing. Opt for speedy e-filing or traditional paper filing. Contact us for expert assistance today.', link: '/filingoptions' },
  ];

  return (
    <div>
      <div className="bgservices">
        <section className="timeline">
          <ul>
            {services.map((service, index) => (
              <li key={index}>
                <div>
                  <time>{service.title}</time>
                  {service.description}
                  <br />
                  <Link to={service.link} className="readmore-link">
                    Read more <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </li>
            ))}
          </ul>
        </section>
      </div>
      <Cosection />
    </div>
  );
};

export default Servicespagesection;
